// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".earn-points-progress .progress{height:1.5rem;margin-top:var(--spacer-1)}", ""]);
// Exports
module.exports = exports;
